import { ToastStateHandler, UserApi } from '../../../api';
import { ICallback } from '../../../commonTypes/hook.types';
import { MedicalLeaveRequestPostDto } from '../../../commonTypes/user.types';
import { ACCESS_TOKEN, ID_TOKEN, LocalStorage } from '../../../util/LocalStorage';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

const MAX_FILE_SIZE_BYTES = 20000000;

const useHttpCreateMedicalLeaveRequest = () => {
    const userApi = useContainer(UserApi);
    const toastHandler = useContainer(ToastStateHandler);
    const storage = useContainer(LocalStorage);
    const { t } = useTranslation('newNotifications');
    const createMedicalLeaveRequest = async (
        { startDate, endDate, description, status, userSub, files }: MedicalLeaveRequestPostDto,
        callback: ICallback
    ) => {
        try {
            if (files && files.some(file => file.size > MAX_FILE_SIZE_BYTES)) {
                toastHandler.push('error', t('medicalLeaveRequest.medicalLeaveRequest'), t('medicalLeaveRequest.maxLimitErrorMessage'));
                return;
            }

            const res = await userApi.createMedicalLeaveRequest({
                startDate,
                endDate,
                description,
                status,
                userSub,
                files,
                accessToken: storage.get(ACCESS_TOKEN),
                idToken: storage.get(ID_TOKEN),
            });

            toastHandler.push('success', t('medicalLeaveRequest.medicalLeaveRequest'), t('medicalLeaveRequest.success'));
            callback.onSuccess?.(res.body);
            return res.body;
        } catch (err: any) {
            console.error(err);
            toastHandler.push(`error`, t('medicalLeaveRequest.medicalLeaveRequest'), t('medicalLeaveRequest.createError'));
            callback.onError?.(err);
        }
    };

    return { createMedicalLeaveRequest };
};
export default useHttpCreateMedicalLeaveRequest;
